import React, { Component } from "react";
import { connect } from "react-redux";

import {
  Card,
  Button,
  Divider,
  Avatar,
  Typography,
  Tag,
  message,
  Modal,
} from "antd";
import { usrRole } from "../../utils/dataUtil";
import {
  getNowAcademicYear,
  getNowAcademicSemester,
} from "../../utils/dateUtil";
//import memoryUtils from '../../utils/memoryUtils'
import {
  req_list_eca_english_course_students,
  req_add_eca_english_course_students,
  req_single_eca_lockedTag,
  req_edit_eca_lockedTag,
  req_list_eca_lockedTagHistory,
} from "../../api";

import ConfigHistoryModal from "./config-history-Modal";

const { Title } = Typography;

class EnglishPointsConfig extends Component {
  // 基礎通用參數 //////////////////////////////////////////////
  state = {
    deviceWidth: 0,
    loading: false,
    userLevel: "NORMAL",
    items: [],
    logs: [],
    item: {},
    nowAcademicYear: getNowAcademicYear(new Date()),
    nowAcademicSemester: getNowAcademicSemester(new Date()),
    canStudentimportStatus: false,
    hasCourseStudentsTotal: 0,
    lockGradesUploadStatus: "N",
    lockStudentViewStatus: "N",
    isShowHistoryModal: false,
  };

  componentDidMount() {
    window.addEventListener("resize", this.resize.bind(this));
    this.resize();
    this.api_init_data();
  }

  // 遠端數據處理 //////////////////////////////////////////////

  api_init_data = async () => {
    const { token, role } = this.props.user;
    var userLevel = usrRole(role);
    this.setState({ userLevel: userLevel });
    // 開關[查詢學習點數] //學生
    const pointssearch = await req_single_eca_lockedTag(
      "POINSTS_SEARCH",
      token
    );
    this.setState({ lockStudentViewStatus: pointssearch.isLocked });
    // 開關[上傳平時成績]
    const gradesupload = await req_single_eca_lockedTag("GRADES_UPLOAD", token);
    this.setState({ lockGradesUploadStatus: gradesupload.isLocked });
    // 開關[匯入學生清單]
    const todayMonth = new Date().getMonth() + 1;
    if (
      todayMonth === 9 ||
      todayMonth === 10 ||
      todayMonth === 2 ||
      todayMonth === 3
    ) {
      this.setState({ canStudentimportStatus: true });
    }
    this.api_get_course_students();
  };

  api_list_logs = async (behavior) => {
    const { token } = this.props.user;
    const result = await req_list_eca_lockedTagHistory(behavior, token);
    if (result.total) {
      const logs = result.total > 0 ? result.data : [];
      this.setState({ logs });
      this.setState({ isShowHistoryModal: true });
    }
  };

  api_modify_courses_students = async () => {
    const { token } = this.props.user;
    const { nowAcademicYear, nowAcademicSemester } = this.state;
    const item = {
      AcademicYear: nowAcademicYear,
      AcademicSemester: nowAcademicSemester,
    };

    this.handle_loading(true);
    const result = await req_add_eca_english_course_students(item, token);
    this.handle_loading(false);

    if (result.status === "success") {
      message.info("匯入成功");
      this.api_get_course_students();
    } else {
      message.error("匯入失敗");
    }
  };

  api_edit_lockedTag_status = async (item) => {
    const { token } = this.props.user;
    await req_edit_eca_lockedTag(item, token);
    await this.api_get_lockedTag_item(item);
  };

  api_get_lockedTag_item = async (item) => {
    const { token } = this.props.user;
    const { behaviorCode } = item;
    const tag = await req_single_eca_lockedTag(behaviorCode, token);
    behaviorCode === "GRADES_UPLOAD"
      ? this.setState({ lockGradesUploadStatus: tag.isLocked })
      : this.setState({ lockStudentViewStatus: tag.isLocked });
  };

  api_get_course_students = async () => {
    const { token } = this.props.user;
    const { nowAcademicYear, nowAcademicSemester } = this.state;
    // 取得已經匯入的人數清單
    const students = await req_list_eca_english_course_students(
      nowAcademicYear,
      nowAcademicSemester,
      token
    );
    this.setState({ hasCourseStudentsTotal: students.total });
  };

  // 操作互動處理 //////////////////////////////////////////////

  resize() {
    this.setState({ deviceWidth: window.innerWidth });
  }

  handle_modify_course_students = () => {
    this.api_modify_courses_students();
  };

  handle_lockedStatus = (type, oldstatus) => {
    const item = {
      condition: "BASE",
      recordModifyUserCode: this.props.user.userCode,
      behaviorCode: type,
      behaviorName: type === "GRADES_UPLOAD" ? "課程成績上傳" : "學生查詢點數",
      isLocked: oldstatus === "Y" ? "N" : "Y",
      logNum: 1,
    };
    this.api_edit_lockedTag_status(item);
  };

  handle_loading = (status) => {
    status === true
      ? message.loading({ content: "作業中...", key: "load" })
      : message.destroy("load");
  };

  handle_show_ui_modal = (type) => {
    //console.log(type);
    switch (type) {
      case "GRADES_UPLOAD":
        this.api_list_logs(type);
        break;
      default:
    }
  };

  /////////////////////////////////////////////////////////////
  render() {
    //console.log(this.props.activity)
    const {
      userLevel,
      nowAcademicYear,
      nowAcademicSemester,
      hasCourseStudentsTotal,
      lockGradesUploadStatus,
      lockStudentViewStatus,
      canStudentimportStatus,
      isShowHistoryModal,
      logs,
    } = this.state;
    const title_start = (
      <Title level={3}>
        <i className="fas fa-tag"></i> 課程學生建立
      </Title>
    );
    const title_midterm = (
      <Title level={3}>
        <i className="fas fa-tag"></i> 學生點數查詢
      </Title>
    );
    const title_end = (
      <Title level={3}>
        <i className="fas fa-tag"></i> 平常成績上傳
      </Title>
    );
    console.log(userLevel);
    return (
      <>
        {userLevel === "CHECKER" ? (
          ""
        ) : (
          <>
            <Divider plan>
              {nowAcademicYear} 學年第 {nowAcademicSemester} 學期{" "}
              <Avatar
                style={{
                  backgroundColor: "DarkGreen",
                  verticalAlign: "middle",
                }}
              >
                初
              </Avatar>
            </Divider>{" "}
            <Card
              title={title_start}
              extra={
                <Button
                  type="primary"
                  onClick={() => this.handle_modify_course_students()}
                  disabled={!canStudentimportStatus}
                >
                  <i className="fas fa-cog"></i>
                  <span style={{ marginLeft: "4px" }}>匯入學生清單</span>
                </Button>
              }
            >
              <p>
                <Tag color="purple">說明</Tag>
                每學期學生完成選課程序後，須將學生清單由教學務系統轉匯本系統，已便後續授課老師輸入成績。
              </p>
              <p>
                <Tag color="purple">限制</Tag>每學年上學期
                <span style={{ fontWeight: "bold", color: "blue" }}>
                  9、10月份
                </span>
                及下學期
                <span style={{ fontWeight: "bold", color: "blue" }}>
                  2、3月份
                </span>
                才會開放作業，其餘時間停匯清單。
              </p>
              <p>
                <Tag color="purple">狀態</Tag>
                <span style={{ fontWeight: "bold" }}>
                  匯入{" "}
                  <span
                    style={
                      hasCourseStudentsTotal > 0
                        ? { color: "green" }
                        : { color: "red" }
                    }
                  >
                    {hasCourseStudentsTotal}
                  </span>{" "}
                  筆
                </span>
              </p>
            </Card>
            <Divider plan>
              {nowAcademicYear} 學年第 {nowAcademicSemester} 學期{" "}
              <Avatar
                style={{ backgroundColor: "Gold", verticalAlign: "middle" }}
              >
                中
              </Avatar>
            </Divider>
            <Card
              title={title_midterm}
              extra={
                <Button
                  type="primary"
                  onClick={() =>
                    this.handle_lockedStatus(
                      "POINSTS_SEARCH",
                      lockStudentViewStatus
                    )
                  }
                >
                  <i className="fas fa-cog"></i>
                  <span style={{ marginLeft: "4px" }}>開放學生查詢</span>
                </Button>
              }
            >
              <p>
                <Tag color="purple">說明</Tag>
                決定是否給學生查看個人學習點數狀況。
              </p>
              <p>
                <Tag color="purple">狀態</Tag>
                <Tag color={lockStudentViewStatus === "Y" ? "#006400" : "#f50"}>
                  {lockStudentViewStatus === "Y" ? "關閉瀏覽" : "開放瀏覽"}
                </Tag>
              </p>
            </Card>
          </>
        )}
        <Divider plan>
          {nowAcademicYear} 學年第 {nowAcademicSemester} 學期{" "}
          <Avatar
            style={{ backgroundColor: "DarkRed", verticalAlign: "middle" }}
          >
            末
          </Avatar>
        </Divider>
        <Card
          title={title_end}
          extra={
            <>
              <Button
                disabled={userLevel === "CHECKER" ? true : false}
                type="primary"
                onClick={() =>
                  this.handle_lockedStatus(
                    "GRADES_UPLOAD",
                    lockGradesUploadStatus
                  )
                }
              >
                <i className="fas fa-cog"></i>
                <span style={{ marginLeft: "4px" }}>開放上傳成績</span>
              </Button>
              <Button
                onClick={() => this.handle_show_ui_modal("GRADES_UPLOAD")}
              >
                <i className="fa fa-list"></i>
                <span style={{ marginLeft: "4px" }}>歷程</span>
              </Button>
            </>
          }
        >
          <p>
            <Tag color="purple">說明</Tag>
            若已完成點數結算，開放授課老師將平時成績轉匯至教學務成績系統。
          </p>
          <p>
            <Tag color="purple">狀態</Tag>
            <Tag
              color={lockGradesUploadStatus === "Y" ? "#006400" : "#f50"}
              size
            >
              {lockGradesUploadStatus === "Y" ? "關閉上傳" : "開放上傳"}
            </Tag>
          </p>
        </Card>
        <Modal
          destroyOnClose={true}
          visible={isShowHistoryModal}
          width={"60%"}
          onOk={() => {
            this.setState({ isShowHistoryModal: false });
          }}
          onCancel={() => {
            this.setState({ isShowHistoryModal: false });
          }}
          cancelButtonProps={{ style: { display: "none" } }}
        >
          <ConfigHistoryModal logs={logs} />
        </Modal>
      </>
    );
  }
}

export default connect(
  (state) => ({ user: state.user }),
  {}
)(EnglishPointsConfig);
